import { useState } from "react";
import { Link } from "react-router-dom";

export default function RegisterSection() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    username: "",
    country: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Registration Data:", formData);
  };

  return (
    <section className="py-5 bg-dark text-light">
      <div className="container">
        <div className="row g-5 align-items-center">

          {/* LEFT: Info */}
          <div className="col-12 col-lg-5">
            <h2 className="fw-bold mb-3">
              Join Our Platform
            </h2>

            <p className="text-light opacity-75 mb-4">
              Create an account to access modern tools, secure features, and
              scalable solutions designed for growth.
            </p>

            <ul className="list-unstyled text-light opacity-75">
              <li className="mb-2">
                <i className="bi bi-check-circle me-2 text-success" />
                Fast onboarding
              </li>
              <li className="mb-2">
                <i className="bi bi-check-circle me-2 text-success" />
                Secure authentication
              </li>
              <li className="mb-2">
                <i className="bi bi-check-circle me-2 text-success" />
                Scalable architecture
              </li>
            </ul>

            <p className="mt-4 small opacity-75">
              Already have an account?{" "}
              <Link to="/page/login" className="text-decoration-none text-info">
                Sign in here
              </Link>
            </p>
          </div>

          {/* RIGHT: Form */}
          <div className="col-12 col-lg-7">
            <div className="card bg-secondary bg-opacity-10 border-0 shadow-sm">
              <div className="card-body p-4 p-lg-5">
                <h3 className="fw-bold mb-4 text-white text-center">
                  Create Account
                </h3>

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">

                    <div className="col-md-6">
                      <label className="form-label text-white">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">Phone</label>
                      <input
                        type="tel"
                        name="phone"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">Username</label>
                      <input
                        type="text"
                        name="username"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.username}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">Country</label>
                      <input
                        type="text"
                        name="country"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.country}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">Password</label>
                      <input
                        type="password"
                        name="password"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label text-white">
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        name="confirmPassword"
                        className="form-control bg-dark text-light border-secondary"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-grid mt-4">
                    <button type="submit" style={{ backgroundColor: "#6f42c1",  }} className="btn btn-lg text-white shadow-none">
                      Register
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>
        <hr className="border-light opacity-25 m-0" />
      </div>
      
    </section>
  );
}
